import { render, staticRenderFns } from "./EditProvider.vue?vue&type=template&id=6c0c58d4&scoped=true&"
import script from "./EditProvider.vue?vue&type=script&lang=js&"
export * from "./EditProvider.vue?vue&type=script&lang=js&"
import style0 from "./EditProvider.vue?vue&type=style&index=0&id=6c0c58d4&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c0c58d4",
  null
  
)

export default component.exports